// This file is auto-generated by scripts/syncLegacyRedirects.mjs. Do not edit manually.
import type { LegacyRedirectEntry } from './types';

export const generatedRedirectMap: LegacyRedirectEntry[] = [
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/',
    sourceQuery: '',
    targetPath: '/locations/malaga-spain',
    reason: 'near-match',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/3-child-seats-across-the-back-seat/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/6-tips-on-how-to-install-a-child-seat-with-a-seat-belt/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/7-benefits-to-hiring-a-travel-buggy/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/about-us/',
    sourceQuery: '',
    targetPath: '/about',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/alquilar-es-la-nueva-moda/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/author/granitewordpress/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/author/olivia/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/author/vicente/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/baby-equipment-hire-dublin-palma-malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/baby-equipment-rental/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/car-hire-and-child-seats/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/car-hire-at-dublin-airport/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/car-seats-faq/',
    sourceQuery: '',
    targetPath: '/faq',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/cart/',
    sourceQuery: '',
    targetPath: '/cart',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/category/airline-travel/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/category/car-hire/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/category/family-holidays/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/category/family-website-we-like/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/category/local-information/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/category/rental/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/category/safety/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/category/uncategorized/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/checkout/',
    sourceQuery: '',
    targetPath: '/checkout',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/child-seat-safety-check-6-common-mistakes-you-can-easily-avoid/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/child-seat-supplier-to-sixt-car-rental-ireland/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/communication-preferences/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/como-instalar-un-asiento-para-ninos-de-forma-segura-6-errores-comunes-que-puede-evitar-facilmente/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/component/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/contact-us/',
    sourceQuery: '',
    targetPath: '/contact',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/covid-19/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/discover-barcelona-with-stork-rentals-new-location-opening-soon/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/discover-malagas-traditional-festivals-in-september-october-a-perfect-time-for-a-family-holiday/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/easter-week-in-malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/family-christmas-in-malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/family-flyingmade-simple-2/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/family-flyingmade-simple/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/faqs/',
    sourceQuery: '',
    targetPath: '/faq',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/feria-de-malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/flying-green/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/frequently-asked/',
    sourceQuery: '',
    targetPath: '/faq',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/growth-of-rental-industry/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/hiking-in-mallorca-with-kids/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/infographic/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/installing-a-child-seat-safetly/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/introducing-the-yoyo-connect-the-ultimate-solution-for-traveling-families/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/marie-kondo-rental-style/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/my-account/',
    sourceQuery: '',
    targetPath: '/login',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/our-baby-products-for-rent/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/our-ethos/',
    sourceQuery: '',
    targetPath: '/about',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/our-favourite-double-buggies/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/partners/',
    sourceQuery: '',
    targetPath: '/partners',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/partners/dublin-airport/',
    sourceQuery: '',
    targetPath: '/partners',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/partners/enterprise-ireland-partner/',
    sourceQuery: '',
    targetPath: '/partners',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/partners/record-go/',
    sourceQuery: '',
    targetPath: '/partners',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/partners/sixt/',
    sourceQuery: '',
    targetPath: '/partners',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/privacy-policy/',
    sourceQuery: '',
    targetPath: '/privacy',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product-category/car-seats/',
    sourceQuery: '',
    targetPath: '/catalogue?location=malaga-spain',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product-category/prams/',
    sourceQuery: '',
    targetPath: '/catalogue?location=malaga-spain',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product-category/travel-crib/',
    sourceQuery: '',
    targetPath: '/catalogue?location=malaga-spain',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product-category/uncategorized/',
    sourceQuery: '',
    targetPath: '/catalogue?location=malaga-spain',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product/babyzen-travel-buggy-parasol/',
    sourceQuery: '',
    targetPath: '/catalogue?location=malaga-spain',
    reason: 'product-fallback',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product/doona-car-seat-and-stroller/',
    sourceQuery: '',
    targetPath: '/product/bf2d4923-1665-4583-8c8d-3ac51fa0d4d7',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product/hire-a-booster-seat/',
    sourceQuery: '',
    targetPath: '/product/e993eb2f-4348-4d6a-8d1b-75872d784021',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product/hire-a-buggy/',
    sourceQuery: '',
    targetPath: '/product/3f60d581-6df9-4606-b318-c297c27e9c36',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product/hire-double-buggy/',
    sourceQuery: '',
    targetPath: '/product/83410922-9d09-4caa-addd-2093d6f01f35',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product/hire-joie-ilevel-baby-seat-base/',
    sourceQuery: '',
    targetPath: '/product/rent-an-infant-seat',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product/infant-travel-system/',
    sourceQuery: '',
    targetPath: '/catalogue?location=malaga-spain',
    reason: 'product-fallback',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product/mirror-for-rear-facing-seats/',
    sourceQuery: '',
    targetPath: '/product/b8969b7c-13a9-4a08-8791-0ecdca8a6a0b',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product/nuna-infant-seat/',
    sourceQuery: '',
    targetPath: '/product/43b45183-0683-45ec-9b67-61acaf4ae54c',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product/pop-up-beach-tent/',
    sourceQuery: '',
    targetPath: '/product/6ecca387-94d0-4c58-b050-0b6a0609c8d7',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product/premium-baby-equipment-rental/',
    sourceQuery: '',
    targetPath: '/catalogue?location=malaga-spain',
    reason: 'product-fallback',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product/rent-a-high-back-booster/',
    sourceQuery: '',
    targetPath: '/product/e993eb2f-4348-4d6a-8d1b-75872d784021',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product/rent-a-pram/',
    sourceQuery: '',
    targetPath: '/catalogue?location=malaga-spain',
    reason: 'product-fallback',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product/rent-a-travel-cot/',
    sourceQuery: '',
    targetPath: '/product/de722e00-0aef-4c3f-a5a5-d49bad327eba',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product/rent-baby-hiking-carrier/',
    sourceQuery: '',
    targetPath: '/product/1f04ea2a-fb13-4304-87b2-a66891247a4d',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product/rent-joie-spin-360-car-seat/',
    sourceQuery: '',
    targetPath: '/product/6036bd44-b416-4842-9ec3-4ffec441d312',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product/sun-shades-for-car-windows/',
    sourceQuery: '',
    targetPath: '/product/cc4233a1-d95e-412b-b80a-7b6ff15cebfc',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product/swim-vest-float-1-3-years/',
    sourceQuery: '',
    targetPath: '/product/a89b25c1-c91a-4851-9819-42bc339c66c1',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product/swim-vest-float-3-6-years/',
    sourceQuery: '',
    targetPath: '/product/e4c76e19-7954-433e-904e-d80a13687bfd',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product/tavo-pet-carrier-medium/',
    sourceQuery: '',
    targetPath: '/product/dfd973a8-9cb2-49d3-8263-34df6079c619',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/product/tavo-pet-carrier-small/',
    sourceQuery: '',
    targetPath: '/product/d5ac05cd-9998-411b-8838-1637405cbec6',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/recordgo-family-car-rental/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/shop/',
    sourceQuery: '',
    targetPath: '/catalogue?location=malaga-spain',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/simple-page/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/stork-recomienda-los-4-mejores-cochecitos-de-viaje/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/stork-recommends-top-4-travel-buggies-3/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/3-child-seats-across-the-back-seat/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/airline-travel/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/alicante/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/baby-equipment-rental/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/baby-seat-rental/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/barcelona/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/car-hire/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/doublebuggies/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/dublin/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/family-holidays-malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/family-travel/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/familytravel/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/familyvacation/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/mallorca/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/recordgo/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/safetravels/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/safety/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/spaininseptember/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/storkadventures/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/storkrental/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/storkrentals/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/travel-buggies/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/travelwithkids/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/vacationcomfort/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/tag/why-buy-when-you-can-hire/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/team/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/team/bourke/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/team/halina-wydrzynska/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/team/levente-fazakas/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/terms-conditions/',
    sourceQuery: '',
    targetPath: '/terms',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/the-airline-broke-my-pram/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/the-best-beaches-of-malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/top-4-travel-buggies/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/travel-buggy-versus-cheap-stroller/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/travel-tips/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/malaga/travelling-with-children-to-spain-or-ireland/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/',
    sourceQuery: '',
    targetPath: '/locations/palma-spain',
    reason: 'near-match',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2019/12/18/family-flyingmade-simple-2/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2019/12/20/car-hire-and-child-seats/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2020/01/09/the-airline-broke-my-pram/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2020/01/19/6-tips-on-how-to-install-a-child-seat-with-a-seat-belt/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2020/01/19/travel-buggy-versus-cheap-stroller/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2020/02/07/family-flyingmade-simple/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2020/02/07/flying-green/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2020/02/23/child-seat-safety-check-6-common-mistakes-you-can-easily-avoid/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2020/02/23/installing-a-child-seat-safetly/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2020/04/07/stork-recommends-top-4-travel-buggies-3/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2020/04/07/top-4-travel-buggies/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2021/05/03/3-child-seats-across-the-back-seat/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2021/06/08/growth-of-rental-industry/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2021/12/07/car-hire-at-dublin-airport/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2021/12/13/travelling-with-children-to-spain-or-ireland/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2021/12/15/family-christmas-in-malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2022/01/26/stork-recomienda-los-4-mejores-cochecitos-de-viaje/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2022/01/27/hiking-in-mallorca-with-kids/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2022/02/15/como-instalar-un-asiento-para-ninos-de-forma-segura-6-errores-comunes-que-puede-evitar-facilmente/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2022/03/24/easter-week-in-malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2022/04/11/alquilar-es-la-nueva-moda/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2022/07/06/feria-de-malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2022/10/11/7-benefits-to-hiring-a-travel-buggy/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2023/03/24/the-best-beaches-of-malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2024/06/15/introducing-the-yoyo-connect-the-ultimate-solution-for-traveling-families/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2024/09/16/discover-malagas-traditional-festivals-in-september-october-a-perfect-time-for-a-family-holiday/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2024/09/25/our-favourite-double-buggies/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2024/12/12/marie-kondo-rental-style/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/2025/01/13/discover-barcelona-with-stork-rentals-new-location-opening-soon/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/about-us-2/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/about-us/',
    sourceQuery: '',
    targetPath: '/about',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/author/olivia/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/author/vicente/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/baby-equipment-hire-dublin-palma-malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/baby-equipment-rental/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/car-seats-rental-spain-faq/',
    sourceQuery: '',
    targetPath: '/faq',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/cart/',
    sourceQuery: '',
    targetPath: '/cart',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/category/airline-travel/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/category/car-hire/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/category/family-holidays/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/category/family-website-we-like/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/category/local-information/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/category/rental/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/category/safety/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/category/uncategorized/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/checkout/',
    sourceQuery: '',
    targetPath: '/checkout',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/child-seat-supplier-to-sixt-car-rental-ireland/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/communication-preferences/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/component/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/contact-us/',
    sourceQuery: '',
    targetPath: '/contact',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/covid-19/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/faqs/',
    sourceQuery: '',
    targetPath: '/faq',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/frequently-asked/',
    sourceQuery: '',
    targetPath: '/faq',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/home-2/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/infographic/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/my-account/',
    sourceQuery: '',
    targetPath: '/login',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/our-baby-products-for-rent/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/our-ethos/',
    sourceQuery: '',
    targetPath: '/about',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/privacy-policy/',
    sourceQuery: '',
    targetPath: '/privacy',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/product-category/car-seats/',
    sourceQuery: '',
    targetPath: '/catalogue?location=palma-spain',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/product-category/prams/',
    sourceQuery: '',
    targetPath: '/catalogue?location=palma-spain',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/product-category/travel-crib/',
    sourceQuery: '',
    targetPath: '/catalogue?location=palma-spain',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/product-category/uncategorized/',
    sourceQuery: '',
    targetPath: '/catalogue?location=palma-spain',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/product/babyzen-travel-buggy-parasol/',
    sourceQuery: '',
    targetPath: '/catalogue?location=palma-spain',
    reason: 'product-fallback',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/product/doona-car-seat-and-stroller/',
    sourceQuery: '',
    targetPath: '/product/bf2d4923-1665-4583-8c8d-3ac51fa0d4d7',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/product/hire-a-booster-seat/',
    sourceQuery: '',
    targetPath: '/product/e993eb2f-4348-4d6a-8d1b-75872d784021',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/product/hire-a-buggy/',
    sourceQuery: '',
    targetPath: '/product/3f60d581-6df9-4606-b318-c297c27e9c36',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/product/hire-double-buggy/',
    sourceQuery: '',
    targetPath: '/product/83410922-9d09-4caa-addd-2093d6f01f35',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/product/hire-joie-ilevel-baby-seat-base/',
    sourceQuery: '',
    targetPath: '/product/rent-an-infant-seat',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/product/infant-travel-system/',
    sourceQuery: '',
    targetPath: '/catalogue?location=palma-spain',
    reason: 'product-fallback',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/product/mirror-for-rear-facing-seats/',
    sourceQuery: '',
    targetPath: '/product/b8969b7c-13a9-4a08-8791-0ecdca8a6a0b',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/product/nuna-infant-seat/',
    sourceQuery: '',
    targetPath: '/product/43b45183-0683-45ec-9b67-61acaf4ae54c',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/product/premium-baby-equipment-rental/',
    sourceQuery: '',
    targetPath: '/catalogue?location=palma-spain',
    reason: 'product-fallback',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/product/rent-a-high-back-booster-2/',
    sourceQuery: '',
    targetPath: '/product/e993eb2f-4348-4d6a-8d1b-75872d784021',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/product/rent-a-pram/',
    sourceQuery: '',
    targetPath: '/catalogue?location=palma-spain',
    reason: 'product-fallback',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/product/rent-a-travel-cot/',
    sourceQuery: '',
    targetPath: '/product/de722e00-0aef-4c3f-a5a5-d49bad327eba',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/product/rent-baby-hiking-carrier/',
    sourceQuery: '',
    targetPath: '/product/1f04ea2a-fb13-4304-87b2-a66891247a4d',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/product/rent-joie-spin-360-car-seat/',
    sourceQuery: '',
    targetPath: '/product/6036bd44-b416-4842-9ec3-4ffec441d312',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/product/sun-shades-for-car-windows/',
    sourceQuery: '',
    targetPath: '/product/cc4233a1-d95e-412b-b80a-7b6ff15cebfc',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/product/swimming-vest-large/',
    sourceQuery: '',
    targetPath: '/product/f6b64bba-fe55-4fe4-9c8c-17f15cc82643',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/product/swimming-vest-medium/',
    sourceQuery: '',
    targetPath: '/product/e4c76e19-7954-433e-904e-d80a13687bfd',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/product/swimming-vest-small/',
    sourceQuery: '',
    targetPath: '/product/a89b25c1-c91a-4851-9819-42bc339c66c1',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/record-go-car-rental-partner-spain/',
    sourceQuery: '',
    targetPath: '/partners',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/record-go-car-rental-partner-spain/dublin-airport/',
    sourceQuery: '',
    targetPath: '/partners',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/record-go-car-rental-partner-spain/enterprise-ireland-partner/',
    sourceQuery: '',
    targetPath: '/partners',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/record-go-car-rental-partner-spain/record-go-car-rental-partner/',
    sourceQuery: '',
    targetPath: '/partners',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/record-go-car-rental-partner-spain/sixt/',
    sourceQuery: '',
    targetPath: '/partners',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/record-go/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/recordgo-family-car-rental/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/shop/',
    sourceQuery: '',
    targetPath: '/catalogue?location=palma-spain',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/simple-page/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/3-child-seats-across-the-back-seat/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/airline-travel/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/alicante/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/baby-equipment-rental/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/baby-seat-rental/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/barcelona/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/car-hire/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/doublebuggies/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/dublin/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/family-holidays-malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/family-travel/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/familytravel/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/familyvacation/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/mallorca/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/recordgo/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/safetravels/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/safety/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/spaininseptember/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/storkadventures/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/storkrental/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/storkrentals/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/travel-buggies/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/travelwithkids/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/vacationcomfort/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/tag/why-buy-when-you-can-hire/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/team/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/team/bourke/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/team/halina-wydrzynska/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/team/levente-fazakas/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/terms-conditions/',
    sourceQuery: '',
    targetPath: '/terms',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.es',
    sourcePath: '/palma/travel-tips/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/3-child-seats-across-the-back-seat/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/7-benefits-to-hiring-a-travel-buggy/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/about-us/',
    sourceQuery: '',
    targetPath: '/about',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/',
    sourceQuery: '',
    targetPath: '/locations/alicante',
    reason: 'near-match',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/3-child-seats-across-the-back-seat/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/6-tips-on-how-to-install-a-child-seat-with-a-seat-belt/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/7-benefits-to-hiring-a-travel-buggy/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/about-us-2/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/about-us-2/our-locations/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/about-us/',
    sourceQuery: '',
    targetPath: '/about',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/alquilar-es-la-nueva-moda/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/author/granitewordpress/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/author/olivia/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/author/vicente/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/baby-equipment-rental-2/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/baby-equipment-rental/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/car-hire-and-child-seats/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/car-hire-at-dublin-airport/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/car-seats-faq/',
    sourceQuery: '',
    targetPath: '/faq',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/cart/',
    sourceQuery: '',
    targetPath: '/cart',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/category/airline-travel/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/category/car-hire/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/category/family-holidays/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/category/family-website-we-like/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/category/local-information/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/category/rental/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/category/safety/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/category/uncategorized/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/checkout/',
    sourceQuery: '',
    targetPath: '/checkout',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/child-seat-safety-check-6-common-mistakes-you-can-easily-avoid/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/child-seat-supplier-to-sixt-car-rental-ireland/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/communication-preferences/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/como-instalar-un-asiento-para-ninos-de-forma-segura-6-errores-comunes-que-puede-evitar-facilmente/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/component/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/contact-us/',
    sourceQuery: '',
    targetPath: '/contact',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/covid-19/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/discover-barcelona-with-stork-rentals-new-location-opening-soon/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/discover-malagas-traditional-festivals-in-september-october-a-perfect-time-for-a-family-holiday/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/easter-week-in-malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/family-christmas-in-malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/family-flyingmade-simple-2/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/family-flyingmade-simple/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/feria-de-malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/flying-green/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/frequently-asked/',
    sourceQuery: '',
    targetPath: '/faq',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/growth-of-rental-industry/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/hiking-in-mallorca-with-kids/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/home/faqs/',
    sourceQuery: '',
    targetPath: '/faq',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/infographic/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/installing-a-child-seat-safetly/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/introducing-the-yoyo-connect-the-ultimate-solution-for-traveling-families/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/marie-kondo-rental-style/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/my-account/',
    sourceQuery: '',
    targetPath: '/login',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/our-baby-products-for-rent-2/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/our-baby-products-for-rent/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/our-ethos/',
    sourceQuery: '',
    targetPath: '/about',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/our-favourite-double-buggies/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/partners/',
    sourceQuery: '',
    targetPath: '/partners',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/partners/dublin-airport/',
    sourceQuery: '',
    targetPath: '/partners',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/partners/enterprise-ireland-partner/',
    sourceQuery: '',
    targetPath: '/partners',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/partners/record-go/',
    sourceQuery: '',
    targetPath: '/partners',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/partners/sixt/',
    sourceQuery: '',
    targetPath: '/partners',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/privacy-policy/',
    sourceQuery: '',
    targetPath: '/privacy',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/product-category/car-seats/',
    sourceQuery: '',
    targetPath: '/catalogue?location=alicante',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/product-category/prams/',
    sourceQuery: '',
    targetPath: '/catalogue?location=alicante',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/product-category/travel-crib/',
    sourceQuery: '',
    targetPath: '/catalogue?location=alicante',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/product-category/uncategorized/',
    sourceQuery: '',
    targetPath: '/catalogue?location=alicante',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/product/hire-a-booster-seat/',
    sourceQuery: '',
    targetPath: '/product/e993eb2f-4348-4d6a-8d1b-75872d784021',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/product/hire-double-buggy/',
    sourceQuery: '',
    targetPath: '/product/83410922-9d09-4caa-addd-2093d6f01f35',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/product/hire-joie-ilevel-baby-seat-base/',
    sourceQuery: '',
    targetPath: '/product/rent-an-infant-seat',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/product/infant-travel-system/',
    sourceQuery: '',
    targetPath: '/catalogue?location=alicante',
    reason: 'product-fallback',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/product/mirror-for-rear-facing-seats/',
    sourceQuery: '',
    targetPath: '/product/b8969b7c-13a9-4a08-8791-0ecdca8a6a0b',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/product/nuna-infant-seat/',
    sourceQuery: '',
    targetPath: '/product/43b45183-0683-45ec-9b67-61acaf4ae54c',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/product/pop-up-beach-tent/',
    sourceQuery: '',
    targetPath: '/product/6ecca387-94d0-4c58-b050-0b6a0609c8d7',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/product/premium-baby-equipment-rental/',
    sourceQuery: '',
    targetPath: '/catalogue?location=alicante',
    reason: 'product-fallback',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/product/rent-a-high-back-booster/',
    sourceQuery: '',
    targetPath: '/product/e993eb2f-4348-4d6a-8d1b-75872d784021',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/product/rent-a-pram/',
    sourceQuery: '',
    targetPath: '/catalogue?location=alicante',
    reason: 'product-fallback',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/product/rent-a-travel-cot/',
    sourceQuery: '',
    targetPath: '/product/de722e00-0aef-4c3f-a5a5-d49bad327eba',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/product/rent-joie-spin-360-car-seat-2/',
    sourceQuery: '',
    targetPath: '/product/6036bd44-b416-4842-9ec3-4ffec441d312',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/product/sun-shades-for-car-windows/',
    sourceQuery: '',
    targetPath: '/product/cc4233a1-d95e-412b-b80a-7b6ff15cebfc',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/product/swim-vest-float-1-3-years/',
    sourceQuery: '',
    targetPath: '/product/a89b25c1-c91a-4851-9819-42bc339c66c1',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/product/swim-vest-float-3-6-years/',
    sourceQuery: '',
    targetPath: '/product/e4c76e19-7954-433e-904e-d80a13687bfd',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/product/tavo-pet-carrier-medium/',
    sourceQuery: '',
    targetPath: '/product/dfd973a8-9cb2-49d3-8263-34df6079c619',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/product/tavo-pet-carrier-small/',
    sourceQuery: '',
    targetPath: '/product/d5ac05cd-9998-411b-8838-1637405cbec6',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/recordgo-family-car-rental/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/shop/',
    sourceQuery: '',
    targetPath: '/catalogue?location=alicante',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/simple-page/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/stork-recomienda-los-4-mejores-cochecitos-de-viaje/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/stork-recommends-top-4-travel-buggies-3/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/3-child-seats-across-the-back-seat/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/airline-travel/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/alicante/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/baby-equipment-rental/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/baby-seat-rental/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/barcelona/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/car-hire/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/doublebuggies/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/dublin/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/family-holidays-malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/family-travel/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/familytravel/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/familyvacation/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/mallorca/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/recordgo/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/safetravels/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/safety/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/spaininseptember/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/storkadventures/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/storkrental/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/storkrentals/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/travel-buggies/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/travelwithkids/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/vacationcomfort/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/tag/why-buy-when-you-can-hire/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/team/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/team/bourke/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/team/halina-wydrzynska/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/team/levente-fazakas/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/terms-conditions/',
    sourceQuery: '',
    targetPath: '/terms',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/the-airline-broke-my-pram/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/the-best-beaches-of-malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/top-4-travel-buggies/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/travel-buggy-versus-cheap-stroller/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/travel-tips/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/travelling-with-children-to-spain-or-ireland/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alicante/work-ith-us-trabaja-con-nosotros/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/alquilar-es-la-nueva-moda/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/author/granitewordpress/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/author/olivia/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/author/vicente/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/baby-equipment-hire-dublin-palma-malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/barcelona/',
    sourceQuery: '',
    targetPath: '/locations/barcelona-spain',
    reason: 'near-match',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/car-hire-and-child-seats/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/car-hire-at-dublin-airport/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/car-hire-partners/',
    sourceQuery: '',
    targetPath: '/partners',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/car-hire-partners/child-seat-supplier-to-sixt-car-rental-ireland/',
    sourceQuery: '',
    targetPath: '/partners',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/car-hire-partners/recordgo-family-car-rental/',
    sourceQuery: '',
    targetPath: '/partners',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/car-hire-partners/supplier-to-enterprise-car-hire/',
    sourceQuery: '',
    targetPath: '/partners',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/cart/',
    sourceQuery: '',
    targetPath: '/cart',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/category/airline-travel/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/category/car-hire/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/category/family-holidays/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/category/family-website-we-like/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/category/local-information/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/category/rental/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/category/safety/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/category/uncategorized/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/checkout/',
    sourceQuery: '',
    targetPath: '/checkout',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/cleaning-process/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/como-instalar-un-asiento-para-ninos-de-forma-segura-6-errores-comunes-que-puede-evitar-facilmente/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/component/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/contact-us/',
    sourceQuery: '',
    targetPath: '/contact',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/discover-barcelona-with-stork-rentals-new-location-opening-soon/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/discover-malagas-traditional-festivals-in-september-october-a-perfect-time-for-a-family-holiday/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/discover-the-revolutionary-doona-i-the-ultimate-car-seat-and-stroller-combo/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/easter-week-in-malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/ensuring-a-safe-journey-our-collaboration-with-recordgo/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/family-christmas-in-malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/faqs/',
    sourceQuery: '',
    targetPath: '/faq',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/feria-de-malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/flying-green/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/frequently-asked/',
    sourceQuery: '',
    targetPath: '/faq',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/growth-of-rental-industry/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/hiking-in-mallorca-with-kids/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/how-to-install-a-child-seat-with-a-seatbelt/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/infographic/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/installing-a-child-seat-safetly/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/introducing-the-yoyo-connect-the-ultimate-solution-for-traveling-families/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/marie-kondo-rental-style/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/my-account/',
    sourceQuery: '',
    targetPath: '/login',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/nuna-pipa-urbn-the-ultimate-car-seat-for-modern-families/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/our-baby-products-for-rent/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/our-car-hire-partners/',
    sourceQuery: '',
    targetPath: '/partners',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/our-ethos/',
    sourceQuery: '',
    targetPath: '/about',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/our-favourite-double-buggies/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/packing-for-a-family-holiday/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/pickup-point/dublin-ireland/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/pickup-point/france/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/pickup-point/ireland/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/pickup-point/malaga-spain/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/pickup-point/palma-spain/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/pickup-point/spain/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/pickup-point/united-kingdom/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/privacy-policy/',
    sourceQuery: '',
    targetPath: '/privacy',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product-category/car-seats/',
    sourceQuery: '',
    targetPath: '/catalogue',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product-category/prams/',
    sourceQuery: '',
    targetPath: '/catalogue',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product-category/travel-crib/',
    sourceQuery: '',
    targetPath: '/catalogue',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product-category/uncategorized/',
    sourceQuery: '',
    targetPath: '/catalogue',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/babybjorn-bouncer/',
    sourceQuery: '',
    targetPath: '/product/rent-a-bouncer',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/babyjogger-citi-mini/',
    sourceQuery: '',
    targetPath: '/product/64d02e79-3803-4220-a4c4-121ee898cdda',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/babyzen-0/',
    sourceQuery: '',
    targetPath: '/product/7392720b-0e58-416c-8161-79ac9f5f043d',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/babyzen-travel-buggy-parasol/',
    sourceQuery: '',
    targetPath: '/catalogue',
    reason: 'product-fallback',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/babyzen-yoyo-connect-accessory/',
    sourceQuery: '',
    targetPath: '/product/5ae2f422-eb84-4abd-8a4c-6681792f73cf',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/carrycot-for-double-buggy/',
    sourceQuery: '',
    targetPath: '/product/edf5cf4e-b36e-4776-aa2b-691206a39af8',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/doona-car-seat-and-stroller/',
    sourceQuery: '',
    targetPath: '/product/bf2d4923-1665-4583-8c8d-3ac51fa0d4d7',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/doona-isofix-base/',
    sourceQuery: '',
    targetPath: '/product/88456c90-e818-4267-bd4c-f85e93f45d41',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/hire-a-buggy/',
    sourceQuery: '',
    targetPath: '/product/3f60d581-6df9-4606-b318-c297c27e9c36',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/hire-britax-kidfix-highback-booster/',
    sourceQuery: '',
    targetPath: '/product/izi-flex',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/hire-joie-ilevel-baby-seat-base/',
    sourceQuery: '',
    targetPath: '/product/rent-an-infant-seat',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/iirvana/',
    sourceQuery: '',
    targetPath: '/product/iirvana',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/iprodigi/',
    sourceQuery: '',
    targetPath: '/product/iprodigi',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/joie-ibold/',
    sourceQuery: '',
    targetPath: '/product/00ea75ee-1e10-47a9-9850-0fccc038c934',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/joie-sprint/',
    sourceQuery: '',
    targetPath: '/product/6b7aef70-fd29-405e-856d-f507f75503bd',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/maxi-cosi-travel-booster-seat/',
    sourceQuery: '',
    targetPath: '/product/59d497c0-2aa0-4919-9fa5-a4e23326e01f',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/maxicosi-nomad-travel-child-seat/',
    sourceQuery: '',
    targetPath: '/product/nomad',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/mirror-for-rear-facing-seats/',
    sourceQuery: '',
    targetPath: '/product/b8969b7c-13a9-4a08-8791-0ecdca8a6a0b',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/nuna-travel-system/',
    sourceQuery: '',
    targetPath: '/product/43b45183-0683-45ec-9b67-61acaf4ae54c',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/rent-a-buggy/',
    sourceQuery: '',
    targetPath: '/product/0d2614a8-5338-4d4a-b507-7f5a78f5f9ff',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/rent-a-double-buggy/',
    sourceQuery: '',
    targetPath: '/product/feb046d6-d4b0-40d4-88c7-5d85e5614f91',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/rent-a-high-back-booster/',
    sourceQuery: '',
    targetPath: '/product/e993eb2f-4348-4d6a-8d1b-75872d784021',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/rent-a-highchair/',
    sourceQuery: '',
    targetPath: '/product/e0e0fa22-6314-4f64-8607-b96f36d15859',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/rent-a-hiking-carrier/',
    sourceQuery: '',
    targetPath: '/product/1f04ea2a-fb13-4304-87b2-a66891247a4d',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/rent-a-travel-cot/',
    sourceQuery: '',
    targetPath: '/product/de722e00-0aef-4c3f-a5a5-d49bad327eba',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/rent-baby-hiking-carrier/',
    sourceQuery: '',
    targetPath: '/product/1f04ea2a-fb13-4304-87b2-a66891247a4d',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/product/rent-joie-spin-360-car-seat/',
    sourceQuery: '',
    targetPath: '/product/6036bd44-b416-4842-9ec3-4ffec441d312',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/record-go/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/ryanairs-family-travel/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/shop/',
    sourceQuery: '',
    targetPath: '/catalogue',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/stork-recomienda-los-4-mejores-cochecitos-de-viaje/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/3-child-seats-across-the-back-seat/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/airline-travel/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/alicante/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/baby-equipment-rental/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/baby-seat-rental/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/barcelona/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/car-hire/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/doublebuggies/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/dublin/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/family-holidays-malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/family-travel/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/familytravel/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/familyvacation/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/mallorca/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/recordgo/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/safetravels/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/safety/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/spain/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/spaininseptember/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/storkadventures/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/storkrental/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/storkrentals/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/travel-buggies/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/travelwithkids/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/vacationcomfort/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/tag/why-buy-when-you-can-hire/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/team/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/team/bourke/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/team/halina-wydrzynska/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/team/john-bernard-donaldson/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/team/levente-fazakas/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/team/sandra-martin/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/team/temi-akilapa/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/terms-conditions/',
    sourceQuery: '',
    targetPath: '/terms',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/the-airline-broke-my-pram/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/the-best-beaches-of-malaga/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/top-4-travel-buggies/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/travel-buggy-versus-cheap-stroller/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/travelling-with-children-to-spain-or-ireland/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/traveltips/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/what-equipment-can-you-bring-on-a-flight-for-free/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
  {
    sourceHost: 'www.storkrentals.ie',
    sourcePath: '/why-cleanliness-matters-the-stork-rentals-advantage-in-baby-car-seats-and-strollers/',
    sourceQuery: '',
    targetPath: '/',
    reason: 'existing-route',
  },
];
